import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type RemoteFixesHeroProps = {
  title: string;
  subtitle: string;
  color: string;
};

/** Status banner — Ghost Screen Remote Fixes.dc.html. */
export function RemoteFixesHero({ title, subtitle, color }: RemoteFixesHeroProps) {
  const { t } = useTranslation('operations');
  return (
    <section
      className="flex flex-wrap items-center gap-x-6 gap-y-4 rounded-2xl border px-6 py-[22px]"
      style={{ background: 'var(--gs-panel)', borderColor: 'var(--gs-line)' }}
    >
      <span className="h-3 w-3 shrink-0 rounded-full" style={{ background: color }} aria-hidden />
      <div className="flex w-full min-w-0 flex-1 flex-col gap-1 sm:min-w-[240px]">
        <span
          className="text-[21px] font-extrabold tracking-[-0.025em]"
          style={{ color: 'var(--gs-ink)' }}
        >
          {title}
        </span>
        <span
          className="text-[14.5px]"
          style={{ color: 'var(--gs-ink2)', lineHeight: 1.45, textWrap: 'pretty' }}
        >
          {subtitle}
        </span>
      </div>
      <Link
        to="/screens"
        className="shrink-0 rounded-[10px] border px-[15px] py-2.5 text-sm font-bold no-underline"
        style={{ color: 'var(--gs-ink)', borderColor: 'var(--gs-line)', background: 'var(--gs-panel)' }}
      >
        {t('hero.goToDisplays')}
      </Link>
    </section>
  );
}
